<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items="logs"
                    name="seyir-area"
                    with-items
                    :fields="fields"
                    pagination="client">
                    <template #additional-actions>
                        <div class="row">
                            <div class="col-md-3 mb-1 mb-md-0">
                                <v-date-picker v-model="date" placeholder="Tarih Seçiniz"></v-date-picker>
                            </div>
                            <div class="col-md-auto mb-1 mb-md-0">
                                <button class="btn btn-success w-100" v-on:click="getReports">
                                    Sorgula
                                </button>
                            </div>
                        </div>
                    </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SeyirApi from '@/api/seyir'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
    },
    data(){
        return{
            date:null,
            fields:Additional.ConvertAutoTable([
                "vehicle",
                "area_id",
                "date",
                "end_time",
                "driver",
                "driver2",
                "duration",
                "fuel",
                "start_fuel_level",
                "end_fuel_level",
                "km",
                "max_speed"
            ],[],'text-nowrap'),
            reports:[]
        }
    },
    methods:{
        getReports(){
            if(this.date){
                this.$refs.table.setLoading(true)
                SeyirApi.GetAreaReport(this.date).then(res=>{
                    this.$refs.table.setLoading(false)
                    if(res.data.Success){
                        this.logs = res.data.Data || []
                    }else this.$result(res)
                    
                })
            }
        }
    }
}
</script>

<style>

</style>